import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { LangScope } from "@/i18n";
import HomePage from "@/pages/HomePage";
import GalleryPage from "@/pages/GalleryPage";

const ScrollReset = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.__lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", { page_path: pathname, page_title: document.title });
    }
  }, [pathname]);
  return null;
};

const Shell = ({ lang, children }) => (
  <LangScope lang={lang}>
    <Navbar />
    {children}
    <Footer />
  </LangScope>
);

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="grain min-h-screen bg-bone text-ink" data-testid="app-root">
      <BrowserRouter>
        <ScrollReset />
        <Routes>
          <Route path="/" element={<Shell lang="en"><HomePage /></Shell>} />
          <Route path="/galleria" element={<Shell lang="en"><GalleryPage /></Shell>} />
          <Route path="/galleria/" element={<Shell lang="en"><GalleryPage /></Shell>} />
          <Route path="/ru" element={<Shell lang="ru"><HomePage /></Shell>} />
          <Route path="/ru/" element={<Shell lang="ru"><HomePage /></Shell>} />
          <Route path="/ru/galleria" element={<Shell lang="ru"><GalleryPage /></Shell>} />
          <Route path="/ru/galleria/" element={<Shell lang="ru"><GalleryPage /></Shell>} />
          <Route path="*" element={<Shell lang="en"><HomePage /></Shell>} />
        </Routes>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: { background: "#1E1E1E", color: "#F5F3F0", border: "1px solid rgba(245,243,240,0.16)", borderRadius: "2px" },
          }}
        />
      </BrowserRouter>
    </div>
  );
}
